import React from 'react';

const ProgressBar = ({ 
  title, 
  progress, 
  target, 
  current, 
  color = '#22C55E',
  backgroundColor = '#E5E7EB',
  height = 8,
  showLabels = true,
  unit = ''
}) => {
  const progressPercentage = Math.min((progress || 0), 100);
  
  const getStatusColor = () => {
    if (progressPercentage >= 90) return '#22C55E'; // green
    if (progressPercentage >= 70) return '#EAB308'; // yellow
    if (progressPercentage >= 50) return '#F97316'; // orange
    return '#EF4444'; // red
  };

  const getStatusText = () => {
    if (progressPercentage >= 100) return 'Objectif atteint !';
    if (progressPercentage >= 90) return 'Presque atteint';
    if (progressPercentage >= 70) return 'Bon progrès';
    if (progressPercentage >= 50) return 'En cours';
    return 'À améliorer';
  };

  const statusColor = getStatusColor();

  return (
    <div className="w-full">
      {title && (
        <div className="flex justify-between items-center mb-2">
          <h4 className="text-sm font-medium text-gray-700">{title}</h4>
          <span className="text-xs px-2 py-1 rounded-full" style={{ 
            backgroundColor: statusColor + '20', 
            color: statusColor 
          }}>
            {getStatusText()}
          </span>
        </div>
      )}
      
      <div className="mb-2">
        <div 
          className="rounded-full overflow-hidden transition-all duration-700"
          style={{ backgroundColor, height: `${height}px` }}
        >
          <div
            className="h-full rounded-full transition-all duration-1000 ease-out"
            style={{
              width: `${progressPercentage}%`,
              backgroundColor: statusColor
            }}
          />
        </div>
      </div>
      
      {showLabels && (
        <div className="flex justify-between text-xs text-gray-500">
          <span>
            {current?.toLocaleString?.() || 0} {unit}
          </span>
          <span className="font-medium">
            {progressPercentage.toFixed(1)}%
          </span>
          <span>
            {target?.toLocaleString?.() || 0} {unit}
          </span>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;